import { PaletteOptions } from '@mui/material/styles';

declare module '@mui/material/styles' {
  interface Palette {
    popup: {
      main: string;
      light: string;
      dark: string;
    };

    generic: {
      main: string;
    };

    gray: {
      main: string;
      light: string;
      dark: string;
      contrastText: string;
    };

    opaqueGray: {
      main: string;
      light: string;
      dark: string;
      contrastText: string;
    };

    focus: {
      main: string;
      light: string;
      dark: string;
      contrastText?: string;
    };
  }

  interface PaletteOptions {
    popup: {
      main: string;
      light: string;
      dark: string;
    };

    generic: {
      main: string;
    };

    gray: {
      main: string;
      light: string;
      dark: string;
      contrastText: string;
    };

    opaqueGray: {
      main: string;
      light: string;
      dark: string;
      contrastText: string;
    };

    focus: {
      main: string;
      light: string;
      dark: string;
      contrastText: string;
    };
  }
}

declare module '@mui/material/TextField' {
  interface TextFieldPropsColorOverrides {
    focus: true;
  }
}
declare module '@mui/material/Button' {
  interface ButtonPropsColorOverrides {
    none: true;
    generic: true;
  }
}

declare module '@mui/material/IconButton' {
  interface IconButtonPropsColorOverrides {
    none: true;
    generic: true;
  }
}

export const palette: PaletteOptions = {
  primary: {
    light: '#F4E4E4',
    main: '#D2232A',
    dark: '#bf0000',
  },
  secondary: {
    main: '#232222',
    contrastText: '#fff',
  },
  error: {
    main: '#bf0000',
  },
  warning: {
    main: '#ffcc00',
    contrastText: '#34A013',
  },
  info: {
    main: '#0063f7',
  },
  success: {
    main: '#00a35c',
  },
  background: {
    default: '#f8f8f8',
  },
  generic: {
    main: '#FFFFFF',
  },

  popup: {
    main: '#D2232A',
    dark: '#000000',
    light: '#2A2A2A',
  },
  gray: {
    main: '#4F4F4F',
    light: '#4F4F4F',
    dark: '#4F4F4F',
    contrastText: '#4F4F4F',
  },
  opaqueGray: {
    main: '#F0F0F0',
    light: '#F0F0F0',
    dark: '#F0F0F0',
    contrastText: '#F0F0F0',
  },
  focus: {
    main: '#3AB3A1',
    light: '#FAFFFD',
    dark: '#3E7C6C',
    contrastText: '#3AB3A1',
  },
};
